import { createApiMutationHook } from "@/hooks/use-api-mutation";
import { UserFcmTokenBindReq, UserFcmTokenBindRes } from "@/types/api/user/user-fcm-token-bind.d";
import { post } from "@/libs/http";

// 绑定fcmToken
export const fcmTokenBind = ({ params }: { params: UserFcmTokenBindReq; }) => {
  return post<UserFcmTokenBindRes>('/user/v1/user/fcmToken/bind', params);
};

export const useFcmTokenBind = createApiMutationHook(fcmTokenBind);